export default __webpack_public_path__ + "src/images/share_icon-bba8cd.jpg";